import { useQuery } from '@tanstack/react-query'
import { qontoApiCall } from '@/services/qontoApi'
import { useQontoConnectionStatus } from '@/hooks/useQontoOAuth'

export interface QontoQuote {
  id: string
  number: string
  status: string
  total_amount: { value: string; currency: string }
  issue_date: string
  expiry_date: string
  quote_url?: string
  contact_email?: string
}

export interface QontoInvoice {
  id: string
  number: string
  status: string
  total_amount: { value: string; currency: string }
  issue_date: string
  due_date: string
  invoice_url?: string
  contact_email?: string
}

/**
 * Recupere les devis depuis Qonto
 */
export function useQontoQuotes() {
  const { data: status } = useQontoConnectionStatus()
  const isConnected = !!status?.connected

  return useQuery({
    queryKey: ['qonto', 'quotes'],
    queryFn: () => qontoApiCall<{ quotes: QontoQuote[] }>('/quotes'),
    enabled: isConnected,
    staleTime: 60_000,
    retry: 1,
  })
}

/**
 * Recupere les factures depuis Qonto
 */
export function useQontoInvoices() {
  const { data: status } = useQontoConnectionStatus()
  const isConnected = !!status?.connected

  return useQuery({
    queryKey: ['qonto', 'invoices'],
    queryFn: () => qontoApiCall<{ client_invoices: QontoInvoice[] }>('/client_invoices'),
    enabled: isConnected,
    staleTime: 60_000,
    retry: 1,
  })
}
